module.exports = __webpack_public_path__ + "img/gfi.ebcaaae1.png";